import { Gift, Store } from "lucide-react";

interface CustomerFooterProps {
  tagline?: string;
  className?: string;
  variant?: "default" | "merchant";
}

// NOTE: Using function declaration instead of const arrow to prevent TDZ errors in production builds
export function CustomerFooter({ 
  tagline = "Smart group gifting & payments", 
  className = "",
  variant = "default"
}: CustomerFooterProps) {
  const faqPath = "/faq";
  
  // Theme colors based on variant
  const themeColor = variant === "merchant" 
    ? "text-primary" 
    : "text-customer";
  const iconColor = variant === "merchant" 
    ? "text-primary" 
    : "text-customer";
  
  const Icon = variant === "merchant" ? Store : Gift;

  return (
    <footer className={`fixed bottom-0 left-0 right-0 border-t border-border bg-card/95 backdrop-blur-sm z-40 ${className}`}>
      <div className="container py-2">
        <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
            <Icon className={`w-3.5 h-3.5 ${iconColor}`} />
            <span className={`font-medium text-sm ${themeColor}`}>Shakatah</span>
            <span className="text-xs text-muted-foreground hidden sm:inline">• {tagline}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <a 
              href="/terms-of-service" 
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Terms
            </a>
            <a 
              href="/privacy-policy" 
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Privacy
            </a>
            <a 
              href="/refund-policy" 
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Refunds
            </a>
            <a 
              href={faqPath} 
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              FAQ
            </a>
            <a 
              href="/contact" 
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Contact
            </a>
            <span className="text-muted-foreground/60 hidden md:inline">
              © {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
